import './App.css'
import React from 'react';
import {BrowserRouter as Router} from "react-router-dom";
import Home from "./stage/home";

function App() {
    return (
        <Router basename={"/BioTools/cocomaps2"}>
            <Home/>
        </Router>
    );
}

export default App;
